import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./Functions.module.scss";
import { Button, makeStyles } from "@material-ui/core";
import { ArrowDropDownOutlined, ArrowDropUpOutlined } from "@material-ui/icons";
import axios from "axios";
import UrlLinks from "../../../UrlLinks";
import ResponseModal from "../../../Utils/dialogs/ResponseModal";
import { useDispatch, useSelector } from "react-redux";
import tableIcon from "../Assets/Table.svg";
import tableDisabledIcon from "../Assets/TableDisabled.svg";
import { createPortal } from "react-dom";
import { bindActionCreators } from "redux";
import * as actionCreators from "../../../store/actions/index";
import { AuthContext } from "../../../services/AuthProvider";

const useStyles = makeStyles((theme) => ({
  statusDropdownDiv: {
    "& .MuiButton-root": {
      border: "1px solid #1c4980",
      color: "#1c4980",
      textTransform: "inherit",
      padding: "5px 9px",
      fontSize: "inherit",
      fontWeight: "normal",
      height: "38px",
    },
    "& .MuiButton-root.Mui-disabled": {
      border: "1px solid #cccccc",
      color: "rgba(0, 0, 0, 0.26)",
    },
  },
  statusDropdownDiv2: {
    "& .MuiButton-root": {
      textTransform: "inherit",
      fontSize: "inherit",
      fontWeight: "normal",
    },
    "& .MuiButton-root.Mui-disabled": {
      color: "rgba(0, 0, 0, 0.26)",
    },
  },
  tcsStatusButton: {
    padding: "0",
    "&:hover": {
      // border:"2px solid red",
      backgroundColor: "transparent",
    },
  },
}));

const CustomStatusDropdown = (props) => {
  const {
    disabled,
    searchList,
    assignIds,
    dropdownName,
    buttonName,
    toggleStatusUpdated,
    setToggleStatusUpdated,
    uniqueKey,
    updateMyData,
    fileName,
    selectedStatusOption,
    sortStatusOrder,
  } = props;
  const { tcsJobsDb } = useSelector((state) => state);
  const { tableValue } = tcsJobsDb;

  /** useDispatch is used to update states to redux store **/

  const dispatch = useDispatch();
  const { setConfigureTable } = bindActionCreators(actionCreators, dispatch);

  const classes = useStyles();
  const { showToast } = useContext(AuthContext);
  const dropdownRef = useRef(null);
  const [statusDropdownOpen, setStatusDropdownOpen] = useState(false);
  const [searchActions, setSearchActions] = useState(
    uniqueKey === "configureTable" ? tableValue : ""
  );
  const [statusList, setStatusList] = useState(searchList);
  const [disableButton, setDisableButton] = useState(false);

  const handleStatusDropdown = (event) => {
    setStatusDropdownOpen(!statusDropdownOpen);
  };

  const handleStatusUpdate = async (itemList) => {
    setDisableButton(true);
    if (uniqueKey === "updateStatusTcs") {
      const data = {
        assignIds: assignIds,
        statusId: searchActions,
      };
      await axios
        .post(
          `${UrlLinks.baseUrl}${
            UrlLinks.tcsGigUrls.updateApplicationStatus
          }?assignId=${data.assignIds}&status=${
            data.statusId
          }&updatedBy=${localStorage.getItem("userID")}`
        )
        .then((response) => {
          if (response.data.code === 1000) {
            showToast("success", "Success", "Remark updated successfully.");
          } else {
            showToast("error", response.data.response);
          }
        })
        .catch((err) => {
          console.log("err", err);
          showToast("error", "Something went wrong, please contact the admin.");
        });
      setToggleStatusUpdated(!toggleStatusUpdated);
      setStatusDropdownOpen(false);
      setSearchActions("");
    }
    updateMyData(itemList.typeKey);
    setDisableButton(false);
  };

  const handleSearchAction = (event, itemList) => {
    setSearchActions(itemList.typeKey);
    if (uniqueKey === "configureTable") {
      setConfigureTable(itemList.typeKey);
      handleStatusUpdate(itemList);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      const dropdown = dropdownRef.current;
      const portalDropdown = document.querySelector(".portal-dropdown");

      if (
        dropdown &&
        !dropdown.contains(event.target) &&
        (!portalDropdown || !portalDropdown.contains(event.target))
      ) {
        setStatusDropdownOpen(false);
        setSearchActions("");
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownRef]);

  useEffect(() => {
    if (uniqueKey === "configureTable") return;
    else if (uniqueKey === "updateStatusTcs") {
      let list = [];
      searchList.map((item) => {
        if (selectedStatusOption.id === "7" && item.id === "9") {
          list.push({
            typeKey: item.id,
            typeValue: item.name,
          });
        } else if (selectedStatusOption.id === "28" && item.id === "36") {
          list.push({
            typeKey: item.id,
            typeValue: item.name,
          });
        } else if (
          selectedStatusOption.id === "30" &&
          (item.id === "31" || item.id === "32")
        ) {
          list.push({
            typeKey: item.id,
            typeValue: item.name,
          });
        } else if (selectedStatusOption.id === "32" && item.id === "30") {
          list.push({
            typeKey: item.id,
            typeValue: item.name,
          });
        }
        return true;
      });
      let sortedList = list.sort((a, b) => {
        return (
          sortStatusOrder.indexOf(a.typeKey) -
          sortStatusOrder.indexOf(b.typeKey)
        );
      });
      setStatusList(sortedList);
    }
  }, [selectedStatusOption, searchList]);

  const dropdownContent = () => {
    return (
      <div
        className={`${styles.statusDropdownList} portal-dropdown`}
        style={{
          width: uniqueKey === "configureTable" ? "163px" : "fit-content",
          zIndex: uniqueKey === "updateStatusTcs" ? 2000 : 1000,
          top: uniqueKey === "updateStatusTcs" ? "270px" : "", // Force it to a visible position
          right: uniqueKey === "updateStatusTcs" ? "180px" : "",
        }}
      >
        {statusList?.map((itemList, index) => (
          <div className={styles.itemList} key={index}>
            <input
              type="radio"
              name="statusOption"
              checked={searchActions === itemList.typeKey}
              onChange={(e) => handleSearchAction(e, itemList)}
            />
            {itemList.typeValue}
          </div>
        ))}
        {uniqueKey !== "configureTable" && (
          <Button
            onClick={(e) => handleStatusUpdate(e, searchActions)}
            variant="contained"
            className="dataButton"
            disabled={searchActions === "" || disableButton ? true : false}
          >
            {buttonName}
          </Button>
        )}
      </div>
    );
  };

  return (
    <div
      ref={dropdownRef}
      className={
        uniqueKey === "updateStatusTcs"
          ? classes.statusDropdownDiv2
          : classes.statusDropdownDiv
      }
    >
      <Button
        onClick={(e) => handleStatusDropdown(e)}
        disabled={disabled}
        className={
          uniqueKey === "updateStatusTcs" ? classes.tcsStatusButton : ""
        }
      >
        {uniqueKey === "configureTable" && (
          <img
            src={disabled ? tableDisabledIcon : tableIcon}
            alt="tableIcon"
            style={{ marginRight: "10px" }}
          />
        )}
        {dropdownName}
        {statusDropdownOpen ? (
          <ArrowDropUpOutlined />
        ) : (
          <ArrowDropDownOutlined />
        )}
      </Button>
      {statusDropdownOpen && uniqueKey === "updateStatusTcs"
        ? createPortal(dropdownContent(), document.body)
        : statusDropdownOpen
        ? dropdownContent()
        : null}
    </div>
  );
};

export default CustomStatusDropdown;
